import { Wallet, HeartPulse, Building2 } from "lucide-react";

const services = [
  {
    icon: Wallet,
    title: "Subsides cantonaux",
    desc: "Vérification d'éligibilité, constitution du dossier et accompagnement de A à Z auprès de votre canton.",
    big: true,
  },
  {
    icon: HeartPulse,
    title: "LAMal — Assurance de base",
    desc: "Choix de la caisse, franchise optimale, modèles alternatifs (HMO, télémédecine).",
  },
  {
    icon: Building2,
    title: "LCA — Complémentaires",
    desc: "Hospitalisation, dentaire, médecines alternatives.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.2em] uppercase font-bold text-spi-red mb-4">
              Nos services
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-spi-blue font-bold">
              Maximisez vos subsides et réduisez vos primes, simplement.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-slate-600 leading-relaxed">
              Bénéficiez d'un accompagnement d'expert de A à Z. Nos spécialistes
              analysent vos droits, optimisent le calcul de votre RDU et prennent
              en charge l'intégralité de vos démarches administratives pour vous
              garantir le montant maximal de subside auquel vous avez droit.
              <strong className="text-spi-blue"> Zéro démarche, zéro stress, uniquement des économies.</strong>
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className={`group p-8 rounded-xl border border-slate-200 bg-white hover:shadow-md transition-all ${
                s.big ? "md:col-span-2 lg:col-span-1 border-spi-blue/30 ring-1 ring-spi-blue/10" : ""
              }`}
            >
              <div className={`inline-flex items-center justify-center w-11 h-11 rounded-lg ${s.big ? "bg-spi-red" : "bg-spi-blue/5"}`}>
                <s.icon
                  className={`w-5 h-5 ${s.big ? "text-white" : "text-spi-blue"}`}
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="mt-6 font-display text-xl text-spi-blue font-semibold">{s.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-sm">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
